var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30146 4.55C7.08524 4.48333 6.86902 4.6 6.8025 4.81667C6.45322 6.06667 5.28898 6.93333 3.99168 6.93333C2.87734 6.93333 1.87942 6.3 1.38046 5.33333H3.06029C3.27651 5.33333 3.45946 5.16667 3.45946 4.93333C3.45946 4.71667 3.29314 4.53333 3.06029 4.53333H0.399168C0.182952 4.53333 0 4.71667 0 4.93333V7.6C0 7.83333 0.182952 8 0.399168 8C0.632017 8 0.798337 7.83333 0.798337 7.6V5.9C1.46362 7.01667 2.67775 7.73333 3.99168 7.73333C5.63825 7.73333 7.10187 6.63333 7.56757 5.05C7.6341 4.83333 7.51767 4.61667 7.30146 4.55ZM7.60083 0C7.36798 0 7.20166 0.183333 7.20166 0.4V2.11667C6.53638 1 5.32225 0.266667 4.00832 0.266667C2.36175 0.266667 0.881497 1.38333 0.4158 2.96667C0.365904 3.16667 0.482328 3.4 0.698545 3.45C0.914761 3.51667 1.13098 3.4 1.18087 3.18333C1.54678 1.95 2.71102 1.06667 4.00832 1.06667C5.10603 1.06667 6.10395 1.71667 6.60291 2.66667H4.93971C4.70686 2.66667 4.54054 2.85 4.54054 3.06667C4.54054 3.3 4.70686 3.46667 4.93971 3.46667H7.60083C7.81705 3.46667 8 3.3 8 3.06667V0.4C8 0.183333 7.81705 0 7.60083 0Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCycle);
export default __webpack_public_path__ + "static/media/img_cycle.2c62060610e892e06b0a764bbfac90e9.svg";
export { ForwardRef as ReactComponent };